import { useMemo, useState } from "react";
import Layout from "@/components/layout/Layout";
import ComicCard from "@/components/feature/ComicCard";
import { comics, categories } from "@/mocks/comics";

const sortOptions = [
  { id: "hot", label: "热度最高" },
  { id: "new", label: "最近更新" },
  { id: "rating", label: "评分最高" },
];

function CategoryPage() {
  const [activeCat, setActiveCat] = useState("all");
  const [activeSort, setActiveSort] = useState("hot");

  const list = useMemo(() => {
    let filtered = activeCat === "all" ? [...comics] : comics.filter((c) => c.categoryId === activeCat);
    if (activeSort === "hot") filtered.sort((a, b) => b.hotScore - a.hotScore);
    if (activeSort === "rating") filtered.sort((a, b) => b.rating - a.rating);
    if (activeSort === "new") filtered.sort((a, b) => (a.isNew === b.isNew ? 0 : a.isNew ? -1 : 1));
    return filtered;
  }, [activeCat, activeSort]);

  return (
    <Layout
      title="尊享专区-尊享漫画|钻石漫画|贵族漫画|豪华漫画|土豪漫画网"
      description="土豪漫画网尊享专区汇集尊享漫画、钻石漫画、贵族漫画、豪华漫画等专属内容，豪华画质，专属特权阅读，尊贵体验一站直达。"
    >
      <section className="relative overflow-hidden pt-28 md:pt-36 pb-8">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-primary-900/30 via-background-950 to-background-950"></div>
          <div className="absolute -left-24 top-10 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl"></div>
        </div>
        <div className="relative mx-auto max-w-7xl px-4 md:px-6">
          <nav className="text-xs text-foreground-500" aria-label="面包屑">
            <ol className="flex items-center gap-2">
              <li><span className="hover:text-primary-300 cursor-pointer">首页</span></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-primary-300">尊享专区</li>
            </ol>
          </nav>
          <h1 className="mt-5 font-heading text-3xl font-black text-foreground-50 md:text-5xl">
            尊享<span className="text-gold-grad">漫画专区</span>
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-foreground-400 md:text-base">
            尊享、钻石、贵族、豪华四大专属漫画专区，豪华画质、极速更新、专属特权阅读，尊贵会员的专属漫画世界。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-6 md:py-10">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap items-center gap-2 rounded-full border border-background-800 bg-background-900/60 p-1">
            {[{ id: "all", name: "全部", icon: "ri-grid-fill" }, ...categories.map((c) => ({ id: c.id, name: c.name, icon: c.icon }))].map(
              (cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCat(cat.id)}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition cursor-pointer ${
                    activeCat === cat.id
                      ? "bg-gradient-to-r from-primary-500 to-accent-500 text-foreground-950"
                      : "text-foreground-300 hover:text-primary-300"
                  }`}
                >
                  <i className={`${cat.icon} text-xs`}></i>
                  {cat.name}
                </button>
              )
            )}
          </div>

          <div className="flex items-center gap-3">
            <span className="text-sm text-foreground-500">共 {list.length} 部作品</span>
            <div className="flex items-center gap-1 rounded-full border border-background-800 bg-background-900/60 p-1">
              {sortOptions.map((opt) => (
                <button
                  key={opt.id}
                  onClick={() => setActiveSort(opt.id)}
                  className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition cursor-pointer ${
                    activeSort === opt.id ? "bg-secondary-500 text-foreground-950" : "text-foreground-400 hover:text-primary-300"
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 lg:grid-cols-4 xl:grid-cols-5">
          {list.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </section>
    </Layout>
  );
}

export default CategoryPage;